<div class="main-container">
	<h3 class="site-notes-nav">
		<span>Site Notes</span>
		<div [ngClass]="{'dont-allow': !allowSiteNotes}">
			<button mat-icon-button (click)="filtersFormModel.patchValue(backupFilters); filtersModal.open()"
				[class.highlighted]="isFilterApplied">
				<mat-icon>filter_list</mat-icon>
			</button>
		</div>
	</h3>
	<h5 *ngIf="!jobId" class="account-name">
		{{userAccountInfoModel.accountName}}
	</h5>
	<h5 *ngIf="jobId" class="account-name">
		{{userAccountInfoModel?.accountSiteInfo?.name}}
	</h5>
	<ng-container *ngIf="!allowSiteNotes">
		<p class="empty-message-container red">This feature is not enabled for your setup.</p>
	</ng-container>
	<ng-container *ngIf="allowSiteNotes">
		<div class="items-list lg-view" [ngClass]="{'extended': !canCreateSiteNote}">
			<p class="empty-message-container" *ngIf="!siteNotes?.length">There are no site notes</p>
			<div  *ngIf="siteNotes?.length">
				<div class="item-container" *ngFor="let siteNote of siteNotes" (click)="redirectToSiteNote(siteNote)">
					<div class="item-details">
						<span class="resource">
							<span *ngIf="siteNote.locationName" class="resource-value">
								<span class="label">Location:</span>{{siteNote.locationName}}
							</span>
						</span>
						<span class="resource">
							<span *ngIf="siteNote.assetName" class="resource-value">
								<span class="label">Asset:</span>{{siteNote.assetName}}
							</span>
						</span>
						<span class="comment">
							{{ siteNote.message }}
						</span>
						
						<span class="emergency" *ngIf="siteNote.isEmergency">
							<span class="label">Emergency:</span>
							YES
						</span>
						
						<span class="notify-other" *ngIf="siteNote.notifyOthers">
							<span class="label">Notify Other:</span>
							{{ siteNote.notifyOthers ? 'YES' : 'NO' }}
						</span>
		
						<span class="created-by-on">
							Posted by {{ siteNote.createdBy }}
							on {{ moment(siteNote.createdOn).format('MM/DD/YYYY hh:mm A') }}
						</span>
		
						<span class="completion-status"
							[class.required]="siteNote.isCompletionRequired && !siteNote.isCompleted"
							[class.completed]="siteNote.isCompletionRequired && siteNote.isCompleted"
							*ngIf="siteNote.isCompletionRequired">
							{{ siteNote.isCompleted ? 'Item Completed' : 'Completion Required' }}
						</span>
						<span class="assigned-to" *ngIf="siteNote.assignedUserName">
							<span class="label">Assigned to:</span>
							{{ siteNote.assignedUserName }}
						</span>
						<span class="completed-by-on" *ngIf="siteNote.isCompletionRequired && siteNote.isCompleted">
							Completed by {{ siteNote.completedBy }}
							on {{ moment(siteNote.completedOn).format('MM/DD/YYYY hh:mm A') }}
						</span>
		
						<span class="photo-count" *ngIf="!!siteNote.photoCount">({{ siteNote.photoCount }} {{
							siteNote.photoCount > 1 ? 'photos' : 'photo' }})</span>	
					</div>
				</div>
			</div>
		</div>
	</ng-container>

</div>
<div *ngIf="canCreateSiteNote" class="actions-container md-view">
	<ng-container>
		<action-button @fadeIn [icon]="ButtonIcons.Add" [name]="'Add'"
			[clickAction]="onAddPressed.bind(self)"></action-button>
	</ng-container>
</div>

<generic-modal #deleteSiteNoteModal class="delete-modal">
	<ng-template #modalBody let-data="data">
		<p>Are you sure you want to delete this Site Note?</p>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-raised-button type="button" class="primary"
			(click)="deleteSiteNote(data.siteNoteId); deleteSiteNoteModal.hide()">Yes</button>
		<button mat-raised-button class="secondary" type="button" (click)="deleteSiteNoteModal.hide()">Cancel</button>
	</ng-template>
</generic-modal>

<generic-modal #filtersModal (onHide)="onHide">
	<ng-template #modalHeading>
		Apply filters
	</ng-template>

	<ng-template #modalBody>
		<div class="main-container">
			<form class="main-form" [formGroup]="filtersFormModel" (keyup.enter)="applyFilters(); filtersModal.hide();">
				<mat-checkbox formControlName="assignedToMe">Assigned to me</mat-checkbox>
				<mat-checkbox formControlName="notCompleted">Not Completed</mat-checkbox>

				<mat-form-field>
					<mat-label>Last number of days</mat-label>
					<input matInput type="number" min="0" max="9999" formControlName="numberOfDays" />
				</mat-form-field>

				<mat-form-field>
					<mat-label>Search</mat-label>
					<input matInput formControlName="searchQuery" />
				</mat-form-field>
			</form>
		</div>
	</ng-template>

	<ng-template #modalActions>
		<button mat-flat-button class="primary" (click)="applyFilters(); filtersModal.hide();">Apply</button>
		<button mat-flat-button (click)="filtersModal.hide()">Cancel</button>
	</ng-template>
</generic-modal>